import { render, staticRenderFns } from "./SemenQuarantine.vue?vue&type=template&id=258794bc&scoped=true&"
import script from "./SemenQuarantine.vue?vue&type=script&lang=js&"
export * from "./SemenQuarantine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258794bc",
  null
  
)

export default component.exports